// extracted by mini-css-extract-plugin
export default {"form":"_03_Profile_form__MQ+T7","root":"_03_Profile_root__LWf6D"};